import React from "react";
import Skeleton from "@mui/material/Skeleton";
import {
  HeaderContainer,
  FundraisingCardContainer,
  StyledEventCard,
  EventCardContainer,
  EventInfoContainer,
  PostersContainer,
  PosterCard,
  ColumnsContainer,
  ColumnBlock,
  SectionHeader,
  SectionContent,
  SubSectionTitle,
  SectionTitle,
} from "./ProjectDetail/ProjectDetail.styles";

export const ProjectHeaderSkeleton = () => (
  <HeaderContainer>
    <Skeleton variant="text" width="40%" height={38} />
    <Skeleton variant="text" width="30%" height={18} />
    <Skeleton variant="text" width="100%" height={70} />
  </HeaderContainer>
);

export const FundraisingSkeletonCard = () => (
  <FundraisingCardContainer>
    <Skeleton variant="text" width="60%" height={22} style={{ margin: 8 }} />
    <Skeleton
      variant="text"
      width="40%"
      height={18}
      style={{ margin: "4px 8px" }}
    />
    <Skeleton
      variant="rectangular"
      width="90%"
      height={10}
      style={{ margin: "12px 8px" }}
    />
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        padding: "0 8px 8px",
      }}
    >
      <Skeleton variant="text" width={60} height={16} />
      <Skeleton variant="text" width={60} height={16} />
    </div>
  </FundraisingCardContainer>
);

export const EventSkeletonCard = () => (
  <StyledEventCard>
    <EventCardContainer>
      <EventInfoContainer>
        <Skeleton variant="text" width="70%" height={20} />
        <Skeleton variant="text" width="50%" height={16} />
        <Skeleton variant="text" width="60%" height={16} />
      </EventInfoContainer>
    </EventCardContainer>
  </StyledEventCard>
);

export const PosterSkeletonCard = () => (
  <PosterCard style={{ width: "48%", marginBottom: ".5rem" }}>
    <Skeleton variant="rectangular" width="100%" height={120} />
    <Skeleton variant="text" width="80%" height={16} style={{ margin: 8 }} />
  </PosterCard>
);

export const ProjectDetailSkeletonLayout = () => (
  <ColumnsContainer>
    <ColumnBlock>
      <SectionHeader>
        <SectionTitle>Fundraising</SectionTitle>
      </SectionHeader>
      <SectionContent style={{ minHeight: "12rem" }}>
        <FundraisingSkeletonCard />
      </SectionContent>
    </ColumnBlock>

    <ColumnBlock>
      <SectionHeader>
        <SectionTitle>Events</SectionTitle>
      </SectionHeader>
      <SectionContent>
        <SubSectionTitle>Upcoming Events</SubSectionTitle>
        {[...Array(2)].map((_, i) => (
          <EventSkeletonCard key={i} />
        ))}
        <SubSectionTitle style={{ marginTop: "1rem" }}>
          Past Events
        </SubSectionTitle>
        <EventSkeletonCard />
      </SectionContent>
    </ColumnBlock>

    <ColumnBlock>
      <SectionHeader>
        <SectionTitle>Posts</SectionTitle>
      </SectionHeader>
      <SectionContent>
        <PostersContainer style={{ marginTop: ".5rem" }}>
          {[...Array(2)].map((_, i) => (
            <PosterSkeletonCard key={i} />
          ))}
        </PostersContainer>
      </SectionContent>
    </ColumnBlock>
  </ColumnsContainer>
);
